import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-384adfb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, computed, onMounted } from "vue";

import Message from "primevue/message";
import Paginator from "primevue/paginator";
import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import TopListEstimationSettingsPanel from "@/entities/analytics/estimation_settings/panels/TopListEstimationSettingsPanel.vue";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import EstimationSettingsTable from "@/entities/analytics/estimation_settings/EstimationSettingsTable.vue";
import EstimationSettingsFilterForm from "@/entities/analytics/estimation_settings/forms/EstimationSettingsFilterForm.vue";

import {
  EstimationSettingsParams,
  useEstimationsSettingsStore,
} from "@/store/analytics/estimation_settings";
import { useAuthStore } from "@/store/auth/login";
import { rowsCount } from "@/services/utils/Pagination";
import { setEstimationSettingsParamsByFilter } from "@/services/analytics/estimation_settings";
import { FilterForm } from "@/services/analytics/estimation_settings";


export default /*#__PURE__*/_defineComponent({
  __name: 'EstimationSettingsPage',
  setup(__props) {

const store = useEstimationsSettingsStore();
const authStore = useAuthStore();
const isLoading = ref(false);
const isFilterEnabled = ref(false);
const isFilterSetted = ref(false);
const tableDisplaySettings = ref({
  first: 0,
  orderField: "",
  commonFilter: "",
  filter: {} as FilterForm,
});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["system:edit"], ["analytics:edit"]);
});

const filteredEstimationSettings = computed(() => {
  return store.estimationSettingsList;
});

const activeFirstFromStore = computed(() => store.activeFirst);

onMounted(() => {
  loadData();
});

const loadData = () => {
  isLoading.value = true;
  updateEstimationSettingsList();
};

const setCommonFilter = (filter: string) => {
  tableDisplaySettings.value.commonFilter = filter;
  updateEstimationSettingsList();
};

const sortTable = (order_by: string) => {
  tableDisplaySettings.value.orderField = order_by;
  updateEstimationSettingsList();
};

const setFilter = (filter: FilterForm, isSetted: boolean) => {
  tableDisplaySettings.value.filter = filter;
  isFilterSetted.value = isSetted;
  updateEstimationSettingsList();
};

const updateEstimationSettingsList = () => {
  let isEnded = false;
  setTimeout(() => {
    if (!isEnded) {
      isLoading.value = true;
    }
  }, 200);
  const params: EstimationSettingsParams = {
    page: tableDisplaySettings.value.first + 1,
    per_page: rowsCount(43),
  };

  setEstimationSettingsParamsByFilter(params, tableDisplaySettings.value);

  store.getEstimationSettings(params).finally(() => {
    isLoading.value = false;
    isEnded = true;
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  });
};

let resizeTimeout: number;

window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateEstimationSettingsList, 200);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsWithTableLayout, null, {
    body: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(EstimationSettingsFilterForm, {
            isFilterEnabled: isFilterEnabled.value,
            onToggleFilter: _cache[0] || (_cache[0] = ($event: any) => (isFilterEnabled.value = !isFilterEnabled.value)),
            onSetFilter: setFilter
          }, null, 8, ["isFilterEnabled"]),
          _createVNode(TopListEstimationSettingsPanel, {
            onSetCommonFilter: setCommonFilter,
            onToggleFilter: _cache[1] || (_cache[1] = ($event: any) => (isFilterEnabled.value = !isFilterEnabled.value)),
            isFilterEnabled: isFilterEnabled.value,
            isFilterSetted: isFilterSetted.value,
            onUpdateTable: updateEstimationSettingsList
          }, null, 8, ["isFilterEnabled", "isFilterSetted"]),
          _createElementVNode("div", {
            id: "table-container",
            class: _normalizeClass(["table-container flex flex-col", [
            filteredEstimationSettings.value && filteredEstimationSettings.value.length == 0
              ? 'empty'
              : 'filled',
          ]])
          }, [
            _createVNode(_unref(Message), {
              severity: "secondary",
              closable: true,
              class: "message-koeff"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Для установки даты начала действия коэффициента воспользуйтесь контекстным меню строки (редактировать по датам).")
              ]),
              _: 1
            }),
            _createVNode(EstimationSettingsTable, {
              "estimations-settings": filteredEstimationSettings.value,
              isActiveFirst: activeFirstFromStore.value,
              isLoading: isLoading.value,
              rowsCount: _unref(rowsCount)(43) * tableDisplaySettings.value.first,
              onSortTable: sortTable,
              onUpdateTable: updateEstimationSettingsList
            }, null, 8, ["estimations-settings", "isActiveFirst", "isLoading", "rowsCount"]),
            (
              filteredEstimationSettings.value &&
              filteredEstimationSettings.value.length == 0 &&
              !isLoading.value
            )
              ? (_openBlock(), _createBlock(EmptyTableMessage, { key: 0 }, {
                  text: _withCtx(() => [
                    _createTextVNode(" Примените другой фильтр или создайте первые настройки. "),
                    _hoisted_1,
                    _createTextVNode(" Для этого кликните на кнопку \"Добавить строку\". ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode(_unref(Paginator), {
            first: tableDisplaySettings.value.first,
            "onUpdate:first": [
              _cache[2] || (_cache[2] = ($event: any) => ((tableDisplaySettings.value.first) = $event)),
              updateEstimationSettingsList
            ],
            rows: 1,
            class: "s-paginator",
            totalRecords: _unref(store).estimationsPagesCount,
            template: "PrevPageLink CurrentPageReport NextPageLink",
            currentPageReportTemplate: "{first} из {totalRecords}"
          }, null, 8, ["first", "totalRecords"])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})